import React from "react";
import { motion } from "framer-motion";

export const SectionHeader = ({ kicker, title, subtitle, align = "left" }) => {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-2xl ${alignClass}`}>
      {kicker && <div className="kicker mb-3" data-testid="section-kicker">{kicker}</div>}
      <motion.h2
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-foreground"
      >
        {title}
      </motion.h2>
      {subtitle && (
        <p className="mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
};
